<template>
	<div class="home">
		<el-container>
			<nav-top :hideHeader="hideHeader"></nav-top>
		</el-container>
		<el-container style="height: 100%">
			<div class="btn" @click="showLeft=!showLeft">
				<img src="../assets/hide.png" v-if="showLeft" />
				<img src="../assets/show.png" v-else />
			</div>
			<el-aside width="80px" v-show="showLeft">
				<left style="position: absolute;left: 0;width: 80px;"></left>
			</el-aside>
			<el-main>
				<div class="mainpanel" :class="{'hide':hideHeader}">
					<router-view />
				</div>
			</el-main>
			<div class="hideButton" :class="{'hide':hideHeader}" @click="hideHeader=!hideHeader">
				<img src="../assets/hide2.png" v-show="!hideHeader" />
				<img src="../assets/show2.png" v-show="hideHeader" />
				<!-- <el-button type="info" size="mini" icon="el-icon-caret-bottom" v-if="hideHeader" @click="hideHeader=!hideHeader"></el-button>
				<el-button type="info" size="mini" icon="el-icon-caret-top" v-else @click="hideHeader=!hideHeader"></el-button> -->
			</div>
		</el-container>
	</div>
</template>

<script>
	import navTop from "@/components/homepage/Header.vue";
	import left from "@/components/homepage/left.vue";
	export default {
		name: "Home",
		components: {
			navTop,
			left,
		},
		data() {
			return {
				showLeft:true,
				hideHeader:false,
			};
		},
		methods: {
		},
	};
</script>
<style scoped lang='less'>
.home {
	height: 100%;
	background: #f1f1f1;
}
.btn{
	width: 30px;
	height: 60px;
	position: absolute;
	top: 85px;
	left: 0px;
	z-index: 99;
	font-size: 18px;
	text-align: center;
	line-height: 30px;
	color:#fff;
	cursor: pointer;
	img{
		width: 18px;
		height: 50px;
		padding: 5px 12px 5px 0px;
	}
}
.hideButton.hide{
	top: 0px;
}
.hideButton{
	position:absolute;
	top: 60px;
	left: 50%;
	transition-duration: 0.25s;
	cursor: pointer;
	img{
		width: 50px;
		height: 16px;
	}
}
.mainpanel.hide{
	padding-top: 0px;	
}
.mainpanel{
	padding-top: 60px;
	transition-duration: 0.25s;
}
</style>
